import React, { useEffect, useState } from 'react'
import axios from 'axios'



function PrintData () {
  const [data, setData] = useState([])
    useEffect(() =>{
    axios.get('http://localhost:8080/catering/hello')
    .then(res =>  setData(res.data))   
     .catch(err => console.log(err));
    }, [])

   
  return (

    <div className='container' align='center'>
    <div>
      <h3 align='center'>fetch data</h3>
      <table className='table'>
        <thead>
          <tr>
            <th>ID</th>
            <th>NAME</th>
          </tr>
        </thead>
        <tbody align='center'>
          {
            data.map((user, index) => {
              return <tr key={index}>
                <td>{user.id}</td>
                <td>{user.name}</td>
              </tr>
            })
          }
        </tbody>
      </table>
    </div>
    </div>
    
  )
  
}


export default PrintData